module.exports = __webpack_public_path__ + "static/img/analysis-template1.91e5a77c.svg";